
export class TicketModel {
  description: string;
  appointmentDate: string;
  patientContactInfo: string;
  timeOfAppointmentCreation: string;
  companyName: string;
  contactName: string;
  contactEmail: string;
  phone: string;

  constructor() {
    this.appointmentDate = '';
    this.companyName = '';
    this.contactEmail = '';
    this.contactName = '';
    this.description = '';
    this.patientContactInfo = '';
    this.phone = '';
    this.timeOfAppointmentCreation = '';
  }
}
